import { useMemo } from 'react';
import type { ConnectedContentMenuItemModel } from 'autogen/swagger/all';
import ContentCard from 'components/ContentCard';
import { mapResponsiveImageModelToImageProps } from 'components/generic/Image/helpers/mapToImageProps';
import DefaultMenuItem from 'components/generic/menu/components/DefaultMenuItem';
import QuickViewArticle from 'components/QuickViewArticle/QuickViewArticle';
import { useQuickView } from 'components/quickView';
import type { LinkAction } from 'components/shared/Routing/components/LinkAction/shared/types';
import getUrlFromPageAction from 'components/shared/Routing/components/shared/getUrlFromPageAction';

export default function SideMenuArticleItem({ item }: { item: ConnectedContentMenuItemModel }) {
    const { link, heading, text = '', image, isQuickView } = item;
    const linkUrl = getUrlFromPageAction(link?.pageAction);
    const { toggle } = useQuickView('inlineConnectedContent');
    const imageProps = useMemo(() => mapResponsiveImageModelToImageProps(image), [image]);

    if (isQuickView && linkUrl) {
        const linkAction = link?.pageAction?.action as LinkAction;

        return (
            <DefaultMenuItem>
                {linkUrl && <QuickViewArticle quickViewId="inlineConnectedContent" linkAction={linkAction} />}

                <ContentCard.Horizontal
                    image={imageProps}
                    heading={text}
                    subheading={heading}
                    onClickWrapper={() => {
                        toggle(true);
                    }}
                />
            </DefaultMenuItem>
        );
    }

    if (link?.pageAction) {
        return (
            <DefaultMenuItem>
                <ContentCard.Horizontal
                    image={imageProps}
                    heading={text}
                    subheading={heading}
                    link={{ action: link.pageAction }}
                />
            </DefaultMenuItem>
        );
    }

    return null;
}
